import { Button, Drawer, TextOrHTML } from "@simplybusiness/mobius";
import "../../Recommendations/RecommendationsDrawer/RecommendationsDrawer.css";

const footerWrapperStyle = {
  padding: "var(--size-lg)",
  background: "var(--color-background)",
  borderTop: "1px solid var(--color-border)",
  flexShrink: 0,
  display: "flex",
};

export type ProductInfoDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  content?: string;
  productId?: string;
  isSelected?: boolean;
  onToggle?: (id: string) => void;
  isUnavailable?: boolean;
};

export const ProductInfoDrawer = ({
  isOpen,
  onClose,
  title,
  content,
  productId,
  isSelected = false,
  onToggle,
  isUnavailable = false,
}: ProductInfoDrawerProps) => {
  const handleCtaClick = () => {
    if (productId && onToggle) {
      onToggle(productId);
    }
    onClose();
  };

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      direction="right"
      closeLabel="Close"
      className="mobius-product-list__drawer"
    >
      <Drawer.Header>{title || "Coverage Details"}</Drawer.Header>
      <Drawer.Content>
        {content && (
          <TextOrHTML
            text={content}
            textWrapper={false}
            htmlElementType="div"
            htmlClassName="mobius-recommendations-drawer__content"
          />
        )}
      </Drawer.Content>
      {onToggle && productId && (
        <div style={footerWrapperStyle}>
          <Button
            variant={isSelected ? "secondary" : "primary"}
            onClick={handleCtaClick}
            isDisabled={isUnavailable}
          >
            {isSelected ? "Remove this coverage" : "Add this coverage"}
          </Button>
        </div>
      )}
    </Drawer>
  );
};
